import { createContext } from "react";

import type { EntityDetailContextValue } from "#app/components/entity/entity-detail-provider";

/** Own module: the provider's module re-runs on hot update, which would recreate the context. */
export const EntityDetailContext = createContext<EntityDetailContextValue | null>(null);
